import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from './AppIcon';

const NavigationBar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const navigationItems = [
    { label: 'Dashboard', path: '/dashboard', icon: 'LayoutDashboard' },
    { label: 'Pipeline', path: '/pipeline-view', icon: 'Kanban' },
    { label: 'Projects', path: '/projects-timeline-view', icon: 'GanttChart' },
    { label: 'Contacts', path: '/contacts-management', icon: 'Users' },
    { label: 'Calendar', path: '/calendar-view', icon: 'CalendarDays' },
    { label: 'Analytics', path: '/deal-analytics-dashboard', icon: 'BarChart3' }
  ];

  const handleNavigation = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false);
  };

  const isActive = (path) => location?.pathname === path;

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      <nav className="nav-bar">
        <div className="nav-bar-logo">
          <div className="nav-bar-logo-icon">
            <Icon name="Briefcase" size={24} color="#FFFFFF" />
          </div>
          <span className="nav-bar-logo-text">SimpleCRM</span>
        </div>

        <div className="nav-bar-menu">
          {navigationItems?.map((item) => (
            <button
              key={item?.path}
              onClick={() => handleNavigation(item?.path)}
              className={`nav-bar-item ${isActive(item?.path) ? 'nav-bar-item-active' : ''}`}
            >
              <div className="flex items-center gap-2">
                <Icon name={item?.icon} size={18} />
                <span>{item?.label}</span>
              </div>
            </button>
          ))}
        </div>
      </nav>
      <button
        onClick={toggleMobileMenu}
        className="nav-bar-mobile-toggle"
        aria-label="Toggle mobile menu"
      >
        <Icon name={isMobileMenuOpen ? 'X' : 'Menu'} size={24} />
      </button>
      <div className={`nav-bar-mobile-menu ${!isMobileMenuOpen ? 'closed' : ''}`}>
        <div className="nav-bar-mobile-header">
          <div className="nav-bar-logo">
            <div className="nav-bar-logo-icon">
              <Icon name="Briefcase" size={24} color="#FFFFFF" />
            </div>
            <span className="nav-bar-logo-text">SimpleCRM</span>
          </div>
        </div>

        <div className="nav-bar-mobile-items">
          {navigationItems?.map((item) => (
            <button
              key={item?.path}
              onClick={() => handleNavigation(item?.path)}
              className={`nav-bar-mobile-item ${isActive(item?.path) ? 'nav-bar-mobile-item-active' : ''}`}
            >
              <div className="flex items-center gap-3">
                <Icon name={item?.icon} size={20} />
                <span>{item?.label}</span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export default NavigationBar;